(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["limited-edition"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    var carousel = document.querySelector('.uppc_list');
    var prevBtn = document.querySelector('.flickity-pdp-prev');
    var nextBtn = document.querySelector('.flickity-pdp-next');

    if (carousel && typeof Flickity !== 'undefined') {
      var flkty = new Flickity(carousel, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false, // we're using custom buttons
        groupCells: 1
      });

      function updateNavButtons() {
        var selectedIndex = flkty.selectedIndex;
        var lastIndex = flkty.slides.length - 1;

        // Add or remove 'finish' class based on position
        if (selectedIndex === 0) {
          prevBtn.classList.add('finished');
        } else {
          prevBtn.classList.remove('finished');
        }

        if (selectedIndex === lastIndex) {
          nextBtn.classList.add('finished');
        } else {
          nextBtn.classList.remove('finished');
        }
      }

      // Initial state
      updateNavButtons();

      // Update on slide change
      flkty.on('change', updateNavButtons);

      // Custom button click bindings
      prevBtn.addEventListener('click', function () {
        flkty.previous();
      });

      nextBtn.addEventListener('click', function () {
        flkty.next();
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
